import {lazy} from 'react';

export const TimebankLazy = lazy(() => import(/* webpackChunkName: "timebank" */ '.'));
